import { ReactNode } from 'react';

export interface ITableColumns {
  id: string;
  key: string;
  title: string | ((props: any) => ReactNode);
  render?: (text: string | number | boolean, props: any, index: number) => ReactNode;
  filterRender?: (key: string) => ReactNode;
  sort?: string;
  width?: string;
  minWidth?: string;
  isSortable?: boolean;
  align?: 'inherit' | 'left' | 'center' | 'right' | 'justify';
  justifyContentHead?: 'inherit' | 'left' | 'center' | 'right' | 'justify';
  isCenterTableHead?: boolean;
  dateFormat?: string;
}

export interface ITableDataSource {
  id: string | number;

  [key: string]: any;
}

export interface ISortOptions {
  property: string;
  direction: ESortDirectionTypes;
}

export enum ESortDirectionTypes {
  ASC = 'ASC',
  DESC = 'DESC',
}

export enum EPerPages {
  perPage25 = 25,
  perPage50 = 50,
  perPage100 = 100,
}

export const mapToEPerPages = (value: unknown): EPerPages => {
  switch (value) {
    case 25:
    case '25':
      return EPerPages.perPage25;
    case 50:
    case '50':
      return EPerPages.perPage50;
    case 100:
    case '100':
      return EPerPages.perPage100;
    default:
      return EPerPages.perPage25;
  }
};
